import { Box, Heading, Text } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import Page from "../components/Page";
import LoginForm from "../components/forms/LoginForm";
import useAuth from "../hooks/useAuth";

export default function Login() {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) return <Navigate to="/" replace />;

  return (
    <Page
      title="تسجيل الدخول"
      maxW="container.sm"
      minH="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      textAlign="center"
    >
      <Box mb={{ base: 8, sm: 12 }}>
        <Text fontSize="2xl" fontWeight="bold" color="teal.400" mb="4">
          لوحة التحكم
        </Text>
        <Heading mb="12" size={{ base: "sm", md: "md" }} fontWeight="bold">
          تسجل الدخول للوحة التحكم
        </Heading>
        <Box
          py={{ base: "0", sm: "8" }}
          px={{ base: "2", sm: "10" }}
          bgColor={{ base: "transparent", sm: "white" }}
          boxShadow={{ base: "none", sm: "md" }}
          borderRadius={{ base: "none", sm: "xl" }}
        >
          <LoginForm />
        </Box>
      </Box>
    </Page>
  );
}
